import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '../fragments';

export default gql`
  mutation actionGenerateHsaInvoice($input: GenerateHsaInvoiceActionInput!) {
    actionGenerateHsaInvoice(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      url
    }
  }
  ${ErrorMessageInfo}
`;
